import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class MyCourse extends Vue {
    @Prop({ default: 14 }) readonly barHeight!: number;
    @Prop({ default: 20 }) readonly percent!: number;
    @Prop({ default: true }) readonly triangle!: boolean;
    @Prop({ default: "#F0F0F0" }) readonly outerColor!: string;
    @Prop({ default: "#0055F9" }) readonly innerColor!: string;

    get per() {
        return isNaN(this.percent) ? 0 : this.percent;
    }
}

// @ts-ignore
export { default as SunProgress } from "./index.vue";
